import { action } from 'typesafe-actions';
import { ReferralsActionTypes } from 'types';

export const fetchReferralHistory = (request?: any) =>
  action(ReferralsActionTypes.FETCH_REFERRAL_HISTORY, request);

export const fetchReferralHistorySuccess = (data: any) =>
  action(ReferralsActionTypes.FETCH_REFERRAL_HISTORY_SUCCESS, data);

export const fetchReferralHistoryFailure = (error: any) =>
  action(ReferralsActionTypes.FETCH_REFERRAL_HISTORY_FAILURE, error);

export const fetchReferralById = (request?: any) =>
  action(ReferralsActionTypes.FETCH_REFERRAL_BYID, request);

export const fetchReferralSuccess = (data: any) =>
  action(ReferralsActionTypes.FETCH_REFERRAL_BYID_SUCCESS, data);

export const fetchReferralFailure = (error: any) =>
  action(ReferralsActionTypes.FETCH_REFERRAL_BYID_FAILURE, error);

export const setReferralSearchFilter = (data: any) =>
  action(ReferralsActionTypes.SET_REFERRAL_SEARCH_FILTER, data);

export const setReferralPresetSearchValues = (data: any) =>
  action(ReferralsActionTypes.SET_REFERRAL_SEARCH_PRESET_VALUES, data);

export const setForwardReferralIsListView = (data: boolean) =>
  action(ReferralsActionTypes.SET_FORWARD_REFERRAL_IS_LIST_VIEW, data);

export const setForwardReferralExternalId = (data: number) =>
  action(ReferralsActionTypes.SET_FORWARD_REFERRAL_EXTERNAL_ID, data);

export const clearAllReferralState = () =>
  action(ReferralsActionTypes.CLEAR_ALL_REFERRAL_STATE);

export const clearReferrals = () =>
  action(ReferralsActionTypes.CLEAR_REFERRALS);

export const connectWebsocketForReferral = (payload: any) =>
  action(ReferralsActionTypes.CONNECT_WEBSOCKET_FOR_REFERRAL, payload);

export const updateEnquiryReferral = (data: any) =>
  action(ReferralsActionTypes.UPDATE_REFERRAL_RESPONSE, data);

export const showReprocessReferralsModal = (
  modalType: 'NONE' | 'ALL' | 'SELECTED'
) => action(ReferralsActionTypes.SHOW_REPROCESS_REFERRALS_MODAL, modalType);

export const reprocessReferrals = (payload: any) =>
  action(ReferralsActionTypes.REPROCESS_REFERRALS_START, payload);

export const reprocessReferralsSuccess = () =>
  action(ReferralsActionTypes.REPROCESS_REFERRALS_SUCCESS);

export const reprocessReferralsFailure = (error: any) =>
  action(ReferralsActionTypes.REPROCESS_REFERRALS_FAILURE, error);

export const reprocessReferralsClear = () =>
  action(ReferralsActionTypes.REPROCESS_REFERRALS_CLEAR);
